import { apiRoutes } from '@features/campaigns/shared/consts/apiRoutes.ts';
import { ListThematicPackagesResponse } from '@features/campaigns/shared/types/thematicPackage.ts';
import { apiClient } from '@shared/api/ApiClient.ts';

export async function listThematicPackages(): Promise<ListThematicPackagesResponse | null> {
  return await apiClient.get<ListThematicPackagesResponse>(apiRoutes.getThematicPackages());
}
